import React from "react";
import Sidebar from "./Sidebar";

function TradesPage() {
  return (
    <div className="app-shell">
      <Sidebar />
      <main className="main-content-area">
        <div className="page-header">
          <div>
            <h1 className="page-title">Trades</h1>
            <p className="page-subtitle">Review and manage your logged trades.</p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default TradesPage;